import DZ_Flag from './A/Algeria 1.svg';
import AO_Flag from './A/Angola 1.svg';
import BJ_Flag from './B/Benin Republic 1.svg';
import BW_Flag from './B/Botswana 1.svg';
import BF_Flag from './B/Burkina Faso 1.svg';
import BI_Flag from './B/Burundi 1.svg';
import CM_Flag from './C/Cameroon 1.svg';
import CV_Flag from './C/Cape Verde 1.svg';
import CF_Flag from './C/Central African Republic 1.svg';
import TD_Flag from './C/chad.png';
import KM_Flag from './C/the Comoros 1.svg';
import CG_Flag from './R/Republic of the Congo 1.svg';
import CD_Flag from './D/DR Congo 1.svg';
import DJ_Flag from './D/Djibouti 1.svg';
import EG_Flag from './E/Egypt 1.svg';
import GQ_Flag from './E/Equatorial Guinea 1.svg';
import ER_Flag from './E/Eritrea 1.svg';
import SZ_Flag from './E/Eswatini 1.svg';
import ET_Flag from './E/Ethiopia 1.svg';
import GA_Flag from './G/Gabon 1.svg';
import GM_Flag from './G/The Gambia 1.svg';
import GH_Flag from './G/Ghana 1.svg';
import GN_Flag from './G/guinea.png';
import GW_Flag from './G/Guinea-Bissau 1.svg';
import CI_Flag from './I/Ivory Coast 1.svg';
import KE_Flag from './K/Kenya 1.svg';
import LS_Flag from './L/Lesotho 1.svg';
import LR_Flag from './L/Liberia 1.svg';
import LY_Flag from './L/Libya 1.svg';
import MG_Flag from './M/Madagascar 1.svg';
import MW_Flag from './M/Malawi 1.svg';
import ML_Flag from './M/mali.png';
import MR_Flag from './M/Mauritania 1.svg';
import MU_Flag from './M/Mauritius 1.svg';
import MA_Flag from './M/Morocco 1.svg';
import MZ_Flag from './M/Mozambique 1.svg';
import NA_Flag from './N/Namibia 1.svg';
import NE_Flag from './N/Niger 1.svg';
import NG_Flag from './N/Nigeria 1.svg';
import RW_Flag from './R/Rwanda 1.svg';
import ST_Flag from './S/São Tomé and Príncipe 1.svg';
import SN_Flag from './S/Senegal 1.svg';
import SC_Flag from './S/Seychelles 1.svg';
import SL_Flag from './S/Sierra Leone 1.svg';
import SO_Flag from './S/Somalia 1.svg';
import ZA_Flag from './S/South Africa 1.svg';
import SS_Flag from './S/South Sudan 1.svg';
import SD_Flag from './S/Sudan 1.svg';
import TZ_Flag from './T/Tanzania 1.svg';
import TG_Flag from './T/Togo 1.svg';
import TN_Flag from './T/Tunisia 1.svg';
import UG_Flag from './U/Uganda 1.svg';
import ZM_Flag from './Z/Zambia 1.svg';
import ZW_Flag from './Z/Zimbabwe 1.svg';
import AG_Flag from './A/Antigua and Barbuda 1.svg';
import BS_Flag from './B/Bahamas 1.svg';
import BB_Flag from './B/Barbados 1.svg';
import DM_Flag from './D/Dominica 1.svg';
import GD_Flag from './G/Grenada 1.svg';
import HT_Flag from './H/Haiti 1.svg';
import JM_Flag from './J/Jamaica 1.svg';
import LC_Flag from './S/Saint Lucia 1.svg';
import KN_Flag from './S/saint-kitts-nevis.png';
import VC_Flag from './S/Saint Vincent and the Grenadines 1.svg';
import TT_Flag from './T/Trinidad and Tobago 1.svg';
import BZ_Flag from './B/belize.png';
import GY_Flag from './G/guyana.png';
import SR_Flag from './S/suriname.png';
import US_Flag from './U/the United States 1.svg';
import GB_Flag from './G/Great Britain 1.svg';
import CA_Flag from './C/Canada 1.svg';
import FR_Flag from './F/France 1.svg';
import DE_Flag from './G/Germany 1.svg';
import BR_Flag from './B/Brazil 1.svg';
import AU_Flag from './A/Australia 1.svg';
import NL_Flag from './N/the Netherlands 1.svg';
import BE_Flag from './B/Belgium 1.svg';
import PT_Flag from './P/Portugal 1.svg';
import ES_Flag from './S/Spain 1.svg';
import IT_Flag from './I/Italy 1.svg';
import SE_Flag from './S/Sweden 1.svg';
import NO_Flag from './N/Norway 1.svg';
import DK_Flag from './D/Denmark 1.svg';
import CH_Flag from './S/Switzerland 1.svg';
import AT_Flag from './A/Austria 1.svg';
import IN_Flag from './I/India 1.svg';
import CN_Flag from './C/China 1.svg';
import JP_Flag from './J/Japan 1.svg';
import KR_Flag from './S/South Korea 1.svg';
import MX_Flag from './M/Mexico 1.svg';
import AR_Flag from './A/Argentina 1.svg';
import CL_Flag from './C/Chile 1.svg';
import CO_Flag from './C/Colombia 1.svg';
import PE_Flag from './P/Peru 1.svg';
import VE_Flag from './V/Venezuela 1.svg';
import AE_Flag from './U/United Arab Emirate 1.svg';
import SA_Flag from './S/Saudi Arabia 1.svg';
import TR_Flag from './T/Türkiye 1.svg';
import RU_Flag from './R/Russia 1.svg';
import PL_Flag from './P/Poland 1.svg';
import IE_Flag from './I/Ireland 1.svg';
import NZ_Flag from './N/New Zealand 1.svg';
import SG_Flag from './S/Singapore 1.svg';
import MY_Flag from './M/Malaysia 1.svg';
import TH_Flag from './T/Thailand 1.svg';
import ID_Flag from './I/Indonesia 1.svg';
import PH_Flag from './P/the Philippines 1.svg';
import VN_Flag from './V/Vietnam 1.svg';
import Soulaan_Flag from './soulaan.png';
import Palestine_PNG from './palestine.png';
import Republic_of_New_Afrika_PNG from './republic_of_new_afrika.png';
import Gullah_Geechie_PNG from './gullah_geechie.png';

// New Global Flags
import PK_Flag from './P/Pakistan 1.svg';
import TR_NEW_Flag from './T/Türkiye 1.svg';
import IL_Flag from './I/Isreal 1.svg';
import QA_Flag from './Qatar 1.svg';
import OM_Flag from './Oman.svg';
import YE_Flag from './Yemen 1.svg';
import AF_Flag from './A/Afghanistan 1.svg';
import AL_Flag from './A/Albania 1.svg';
import BD_Flag from './B/Bangledesh 1.svg';
import RO_Flag from './R/Romania 1.svg';
import UA_Flag from './U/Ukraine 1.svg';
import PL_NEW_Flag from './P/Poland 1.svg';
import GR_Flag from './G/Greece 1.svg';
import FI_Flag from './F/Finland 1.svg';
import IS_Flag from './I/Iceland 1.svg';
import CR_Flag from './C/Costa Rica 1.svg';
import CU_Flag from './C/cuba.png';
import DO_Flag from './D/dominican-republic.png';
import PA_Flag from './P/Panama 1.svg';
import UY_Flag from './U/Uruguay 1.svg';
import PY_Flag from './P/Paraguay 1.svg';
import BO_Flag from './B/Bolivia 1.svg';
import EC_Flag from './E/Ecuador 1.svg';
import FJ_Flag from './F/Fiji 1.svg';
import PG_Flag from './P/Papua New Guinea 1.svg';
import WS_Flag from './S/Samoa 1.svg';
import TO_Flag from './T/Tonga 1.svg';
import VU_Flag from './V/Vanuatu 1.svg';

// Afro-Caribbean and African overseas territories. The artwork for all of
// these was already in the repo, unreferenced, which is why they were absent
// from the app rather than merely unstyled.
import GP_Flag from './G/Guadeloupe 1.svg';
import MQ_Flag from './M/Martinique 1.svg';
import GF_Flag from './F/French Guiana 1.svg';
import PR_Flag from './P/Puerto Rico 1.svg';
import CW_Flag from './C/Curacao 1.svg';
import AW_Flag from './A/Aruba 1.svg';
import BQ_Flag from './B/Bonaire 1.svg';
import BM_Flag from './B/Bermuda 1.svg';
import KY_Flag from './C/the Cayman Islands 1.svg';
import TC_Flag from './T/the Turks and Caicos Islands 1.svg';
import VI_Flag from './U/the United States Virgin Islands 1.svg';
import AI_Flag from './A/Anguilla 1.svg';
import MS_Flag from './M/Montserrat 1.svg';
import YT_Flag from './M/Mayotte 1.svg';
import SH_Flag from './S/Saint Helena, Ascension and Tristan da Cunha 1.svg';


// Need to handle both string (URL) and StaticImageData (imported PNG)
export const flagImages: Record<string, any> = {
  'gp': GP_Flag,
  'mq': MQ_Flag,
  'gf': GF_Flag,
  'pr': PR_Flag,
  'cw': CW_Flag,
  'aw': AW_Flag,
  'bq': BQ_Flag,
  'bm': BM_Flag,
  'ky': KY_Flag,
  'tc': TC_Flag,
  'vi': VI_Flag,
  'ai': AI_Flag,
  'ms': MS_Flag,
  'yt': YT_Flag,
  'sh': SH_Flag,
  'soulaan': Soulaan_Flag,
  'dz': DZ_Flag,
  'ao': AO_Flag,
  'bj': BJ_Flag,
  'bw': BW_Flag,
  'bf': BF_Flag,
  'bi': BI_Flag,
  'cm': CM_Flag,
  'cv': CV_Flag,
  'cf': CF_Flag,
  'td': TD_Flag,
  'km': KM_Flag,
  'cg': CG_Flag,
  'cd': CD_Flag,
  'dj': DJ_Flag,
  'eg': EG_Flag,
  'gq': GQ_Flag,
  'er': ER_Flag,
  'sz': SZ_Flag,
  'et': ET_Flag,
  'ga': GA_Flag,
  'gm': GM_Flag,
  'gh': GH_Flag,
  'gn': GN_Flag,
  'gw': GW_Flag,
  'ci': CI_Flag,
  'ke': KE_Flag,
  'ls': LS_Flag,
  'lr': LR_Flag,
  'ly': LY_Flag,
  'mg': MG_Flag,
  'mw': MW_Flag,
  'ml': ML_Flag,
  'mr': MR_Flag,
  'mu': MU_Flag,
  'ma': MA_Flag,
  'mz': MZ_Flag,
  'na': NA_Flag,
  'ne': NE_Flag,
  'ng': NG_Flag,
  'rw': RW_Flag,
  'st': ST_Flag,
  'sn': SN_Flag,
  'sc': SC_Flag,
  'sl': SL_Flag,
  'so': SO_Flag,
  'za': ZA_Flag,
  'ss': SS_Flag,
  'sd': SD_Flag,
  'tz': TZ_Flag,
  'tg': TG_Flag,
  'tn': TN_Flag,
  'ug': UG_Flag,
  'zm': ZM_Flag,
  'zw': ZW_Flag,
  'ag': AG_Flag,
  'bs': BS_Flag,
  'bb': BB_Flag,
  'dm': DM_Flag,
  'gd': GD_Flag,
  'ht': HT_Flag,
  'jm': JM_Flag,
  'lc': LC_Flag,
  'kn': KN_Flag,
  'vc': VC_Flag,
  'tt': TT_Flag,
  'bz': BZ_Flag,
  'gy': GY_Flag,
  'sr': SR_Flag,
  'us': US_Flag,
  'gb': GB_Flag,
  'ca': CA_Flag,
  'fr': FR_Flag,
  'de': DE_Flag,
  'br': BR_Flag,
  'au': AU_Flag,
  'nl': NL_Flag,
  'be': BE_Flag,
  'pt': PT_Flag,
  'es': ES_Flag,
  'it': IT_Flag,
  'se': SE_Flag,
  'no': NO_Flag,
  'dk': DK_Flag,
  'ch': CH_Flag,
  'at': AT_Flag,
  'in': IN_Flag,
  'cn': CN_Flag,
  'jp': JP_Flag,
  'kr': KR_Flag,
  'mx': MX_Flag,
  'ar': AR_Flag,
  'cl': CL_Flag,
  'co': CO_Flag,
  'pe': PE_Flag,
  've': VE_Flag,
  'ae': AE_Flag,
  'sa': SA_Flag,
  'tr': TR_Flag,
  'ru': RU_Flag,
  'pl': PL_Flag,
  'ie': IE_Flag,
  'nz': NZ_Flag,
  'sg': SG_Flag,
  'my': MY_Flag,
  'th': TH_Flag,
  'id': ID_Flag,
  'ph': PH_Flag,
  'vn': VN_Flag,
  'pk': PK_Flag,
  'tr_new': TR_NEW_Flag,
  'il': IL_Flag,
  'qa': QA_Flag,
  'om': OM_Flag,
  'ye': YE_Flag,
  'af': AF_Flag,
  'al': AL_Flag,
  'bd': BD_Flag,
  'ro': RO_Flag,
  'ua': UA_Flag,
  'pl_new': PL_NEW_Flag,
  'gr': GR_Flag,
  'fi': FI_Flag,
  'is': IS_Flag,
  'cr': CR_Flag,
  'cu': CU_Flag,
  'do': DO_Flag,
  'pa': PA_Flag,
  'uy': UY_Flag,
  'py': PY_Flag,
  'bo': BO_Flag,
  'ec': EC_Flag,
  'fj': FJ_Flag,
  'pg': PG_Flag,
  'ws': WS_Flag,
  'to': TO_Flag,
  'vu': VU_Flag,
  'ps': Palestine_PNG,
  'rna': Republic_of_New_Afrika_PNG,
  'gg': Gullah_Geechie_PNG,
};

export function getFlagImage(countryCode: string): string | undefined {
  const flag = flagImages[countryCode.toLowerCase()];
  if (!flag) return undefined;
  
  // If it's a StaticImageData object (from PNG import), return .src
  if (typeof flag === 'object' && flag !== null && 'src' in flag) {
    return flag.src;
  }
  
  // If it's a string (SVG path or URL), return as is
  return flag as string;
}
